export const mailsES = {
  checkpoint:
    'Tienes que confirmar el correo electrónico para poder visualizar los ejercicios',
  verification: {
    expired: 'Código inválido o caducado',
    verificated: 'La cuenta ha sido verificada',
    processing: 'AptisGo está procesando su verificación'
  }
}
